import { createSelector } from '@ngrx/store';
import { BootState } from 'sp-mark/feature-modules/boot/redux/boot.reducers';
import { AppState } from 'sp-mark/redux';
import { LocalUnit } from 'sp-ui-lib';

const selectFeature = (appState: AppState) => appState.boot;

export const flagInitializationCompleted = createSelector(
    selectFeature,
    (state: BootState) => state ? state.flagInitializationCompleted : undefined
);

export const selectLocalUnits = createSelector(
    selectFeature,
    (state: BootState) => state ? state.localUnits.slice().sort((a, b) => {
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        return 0;
    }) : undefined
);

export const selectAvailableLocalUnits = createSelector(
    selectFeature,
    (state: BootState) => state ? state.localUnits : undefined
);

export const selectActiveLocalUnits = createSelector(
    selectFeature,
    (state: BootState) => {
        if (!!state) {
            const localUnitsSelected: LocalUnit[] = state.localUnits.filter(localUnit => localUnit.flagSelected);
            return localUnitsSelected.length !== 0 ? localUnitsSelected : state.localUnits;
        }
        return [];
    }
);

export const selectLoggedMerchant = createSelector(
    selectFeature,
    (state: BootState) => state ? state.loggedMerchant : undefined
);

export const selecLocalUnitByNumber = createSelector(
    selectFeature,
    (state: BootState, props: number[]) => state ? state.localUnits
        .filter(lu => props.includes(lu.id))
        .map(lu => lu.name) : undefined
);

export const selectLocalUnitsDisabled = createSelector(
    selectFeature,
    (state: BootState) => state ? state.flagLocalUnitsDisabled : undefined
);

export const selectLocalUnitsCompletlyDisabled = createSelector(
    selectFeature,
    (state: BootState) => state ? state.flagLocalUnitsCompletlyDisabled : undefined
);

export const getLocalUnitName = createSelector(
    selectLocalUnits,
    (localUnits: LocalUnit[], props: number) => localUnits ? localUnits.find(unit => unit.id === props).name : undefined
);

export const selectSteps = createSelector(
    selectFeature,
    (state: BootState) => state ? state.steps : undefined
);

export const selectCurrentStep = createSelector(
    selectFeature,
    (state: BootState) => state && state.steps ? state.steps[state.currentStepIndex] : undefined
);
